<template>
<!-- :height="tableHeight" -->
  <TableList
    ref="table"
    :cols="cols"
    :list="list"
    :selection="true"
    :rowHeight="130"
    height="420px"
    @selection-change="selectedChange"
  >
    <template slot="mainImagesSlot" slot-scope="{ row }">
      <div style="display: flex; align-items: center; position: relative;">
        <div v-if="row.isTop" class="recommend-tag absolute">
          推荐
        </div>
        <ListLazyImg :src="`${row.mainImages[0]}`" />
      </div>
    </template>
    <template slot="titleSlot" slot-scope="{ row }">
      <el-tooltip effect="dark" :content="row.title" placement="top">
        <span class="line-ellipsis">{{ row.title }}</span>
      </el-tooltip>
    </template>
    <template slot="privacyStateSlot" slot-scope="{ row }">
      <div class="privacyState-label" :class="row.privacyState === 1 ? 'orange' : 'green'">{{ row.privacyState === 1 ? '分销商可见' : '所有人可见' }}</div>
    </template>
    <template slot="categoryIdSlot">
      <div>未分类</div>
    </template>
    <template slot="levelDistributionPriceSlot" slot-scope="{ row }">
      <div>{{row.levelDistributionPrice === -1 ? '合作后查看' : (row.levelDistributionPrice || '-')}}</div>
    </template>
    <template slot="distributionPriceListSlot" slot-scope="{ row }">
      <div v-if="row.distributionPriceList">
        <div
          v-for="item in row.distributionPriceList"
          :key="item.level"
        >
          {{item.level}}级：{{item.price}}
        </div>
      </div>
      <div v-else>
        -
      </div>
    </template>
  </TableList>
</template>

<script>
import TableList from "@/components/ColsTable/index.vue";
import ListLazyImg from '@/components/ListLazyImg/index.vue';
import StatusBtn from "@/components/prod/center/components/StatusBtn.vue";
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: "supplier",
    },
  },
  data() {
    return {
      cols: [
        {prop: "mainImages",attrs: { label: "图片", width: "90px" },slot: true,},
        {prop: "outerId", attrs: { label: "款式编码", width: "180px", 'class-name': 'outerId-cell', 'show-overflow-tooltip': true } },
        {prop: "privacyState", attrs: { label: "公开/私密", width: "100px"}, slot: true },
        {prop: "title",attrs: {label: "商品名",width: "180px", "show-overflow-tooltip": true,},slot: true,},
        {prop: "categoryId",attrs: { label: "橱窗分类", width: "80px" }, slot: true,},
        {prop: "levelDistributionPrice", attrs: { label: "分销价（未合作）", width: "120px" }, slot: true,},
        {prop: "distributionPriceList", attrs: { label: "1-5级分销价（已合作）", width: "150px" }, slot: true,},
        {prop: "distributionTime", attrs: { label: "上新时间", width: "160px" }},
      ],
      selectedArr: []
    }
  },
  components: {
    TableList,
    ListLazyImg,
    StatusBtn
  },
  methods: {
    selectedChange(val) {
      if (this.selectedArr.length > 10) {
        this.$message.warning('选择商品不能超过10个');
      }
      this.selectedArr = val;
      this.$emit('updateSelectedArr', val);
    },
    method_getSelectedArr() {
      return this.selectedArr;
    },
  }
}
</script>

<style lang="scss" scoped>
.privacyState-label {
  padding: 2px 4px;
  border-radius: 2px;
  text-align: center;
  &.orange {
    color: #FBB62B;
    background-color: rgba(251, 182, 43, 0.15);
    border: 1px solid rgba(251, 182, 43, 0.3);
  }
  &.green {
    color: #69CC38;
    background-color: rgba(105, 204, 56, 0.15);
    border: 1px solid rgba(105, 204, 56, 0.3);
  }
}
.recommend-tag {
  top: 0px;
  right: -4px;
  color: #fff;
  width: 38px;
  height: 20px;
  line-height: 20px;
  background: #2695FA;
  text-align: center;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 8px;
  transform: scale(0.8);
  z-index: 1;
}
</style>
